module.exports = __webpack_public_path__ + "img/Flag_of_Uganda.f8bb736e.svg";